import React from "react"
import * as AppConstants from "../../../utility/AppConstants"
import InfoRiservatezza from "../../avvisi/InfoRiservatezza"
import InfoTotali from "../../avvisi/InfoTotali"

import { Table } from "@sogei/react-web-components-catalog"
import 'Css/table.css'
function TabTotali(props: any) {
    return (
        <div  role="tabpanel">
            <div className="row">
                <div className="col-12 ">
                    <div className="table-responsive">
                        <Table
                            tableHead={
                                <tr>
                                    <th>
                                        {AppConstants.TITLE_REGIONE.toUpperCase()}
                                    </th>
                                    <th className="th-statistiche">
                                        {AppConstants.TITLE_NUM_POSIZIONI}
                                    </th>
                                    <th className="th-statistiche">
                                        {AppConstants.TITLE_NUM_ADDETTI}
                                    </th>
                                    <th className="th-statistiche">
                                        {AppConstants.TITLE_RICAVI_COMPENSI}
                                    </th>
                                    <th className="th-statistiche">
                                        {AppConstants.TITLE_REDDITI}
                                    </th>
                                    <th className="th-statistiche">
                                        {AppConstants.TITLE_PUNTEGGIO_ISA}
                                    </th>
                                    {/*<th className="th-statistiche th_punteggio_isa">{AppConstants.TITLE_PUNTEGGIO_ISA_NO_ANOMALIE}</th>*/}
                                </tr>
                            }
                            tableBody={props.datiRegionali.elementiRegionali.map(
                                (dati: any, key: number) => (
                                    <tr className="tableStatIsa" key={key}>
                                        {dati.regione.toUpperCase() ===
                                        AppConstants.TITLE_TOTALE ? (
                                            <th>{dati.regione} *</th>
                                        ) : (
                                            <th>{dati.regione}</th>
                                        )}

                                        <td>{dati.numeroPosizioni}</td>
                                        <td>{dati.numeroAddetti}</td>
                                        <td>{dati.ricaviCompensi}</td>
                                        <td>{dati.redditi}</td>
                                        <td>{dati.punteggioIsaAnomalie}</td>
                                        {/*<td>{dati.punteggioIsaSenzaAnomalie}</td>*/}
                                    </tr>
                                )
                            )}
                            tableOptions={["table-striped"]}
                        >
                            <caption className="sr-only">
                                {AppConstants.TITLE_REGIONE}
                            </caption>
                        </Table>
                    </div>
                </div>
            </div>

            <InfoRiservatezza />
            <InfoTotali />
        </div>
    )
}
export default TabTotali
